import React from "react";
import previewImage from "../../project_previews/worm.jpg"; // Adjust the path accordingly


function Worm() {
  return (
      <div
      name="worm"
      className="min-h-screen w-full bg-[#0a192f] text-gray-300 pt-[80px] pb-28 xl:pb-24 flex flex-col items-center"
      >
        <div className="w-full bg-[#0a192f] text-center py-8">
        <h1 className="text-4xl font-bold text-cyan-500">Would you still love me if I was a worm?</h1>
        </div>


        <img
        src={previewImage}
        alt="Preview"
        className="w-[800px] h-auto rounded-lg shadow-lg mb-4"
        />

        <div className="w-full lg:w-[60%] text-lg lg:text-4xl text-left leading-relaxed mb-4">
        <p><b>TLDR:</b> In 2024, I created a short video game called "Would You Love Me If I Was a Worm?"
        with a small group of women in the Video Game Design course at Georgia Tech. In the game, you 
        play a teenage girl turned worm, who quests only to answer 1 question: does her boyfriend still love her?
        </p>
        </div>

        <br></br>  
        

        <div className="w-full lg:w-[60%] text-lg lg:text-xl text-left">
        <p style={{ color: "#00FF00" }}><a href="https://www.instagram.com/reels/C6EriCYOWJL/"><u>Watch the trailer here</u></a></p>
        <br></br>
        <p>In 2024, I took the video game design course in the master degree program at Georgia Tech. By some chance of fate, I ended up
          in a group with all women, a rare occurrence in the software world. We decided to take the opportunity to create a game that 
          resonated with us, and that is how we ended up creating a game out of the meme: "Would you still love me if I was a worm?" 
        </p>  
        <br></br>
         <p>
          The game is a short, narrative driven experience where you play a teenage girl who has been turned into a worm. You must journey
          across the bedroom, which is suddenly gigantic in your tiny worm body. You have to avoid the cat, crawl up a desk, and text your 
          boyfriend the ultimate question: "Do you still love me?". Along the way, you discover mementos of your relationship, confronting you 
          with the question: "Is this relationship actually worth fighting for?" In the end, both of you have a decision to make.
         </p> 
         <br></br>
        <p>
          I was responsible for much of the narrative, the worm controls and animations, and the logic behind the collectibles in the game. 
        </p>
        <br></br>
        <p>While we did not take our game to a release, I learned a lot about programming in Unity for this project, and got to dust off
          the old animation skills. It was a lot of fun, and I ever have the chance to work on a game again, I would love to do it.
        </p>

        </div>

        

      </div>
    );

}
export default Worm;